import { Button } from '@mui/material'
import { FC, useContext } from 'react'

import { useTranslation } from 'react-i18next'
import closeIcon from '../../../../../assets/images/icons/x-close.svg'
import { UserDataContext } from '../../../../../providers/contexts/UserDataProvider'
import CustomModal from '../../../../modals/custom-modal'
import styles from './opt-in-status-modal.module.scss'

type OptInStatusModalModalProps = {
    open: boolean
    closeModal: () => void
}

export const OptInStatusModal: FC<OptInStatusModalModalProps> = ({
    open,
    closeModal,
}) => {
    const { userData } = useContext(UserDataContext)
    const { t } = useTranslation()

    return (
        <CustomModal open={open}>
            <div className={styles['header']}>
                <h1
                    className={styles['title']}
                >{`Hey, ${userData.businessName} `}</h1>
                <img
                    className={styles['close']}
                    onClick={closeModal}
                    src={closeIcon}
                    alt="x"
                />
            </div>
            <div className={styles['main']}>
                <div className={styles['terms-container']}>
                    <div className={styles['terms-text']}>
                        <p>
                            {t('rewards_program_opt.opt_in_status_content_1')}
                        </p>
                        <p>
                            {t('rewards_program_opt.opt_in_status_content_2')}
                        </p>
                    </div>
                </div>

                <div className={styles['button-container']}>
                    <Button
                        variant="contained"
                        type="submit"
                        className="secondary-btn"
                        id="myBtn"
                        onClick={closeModal}
                    >
                        {t('rewards_program_opt.redeem_now')}
                    </Button>
                </div>
            </div>
        </CustomModal>
    )
}
